import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';
import withRouter from 'react-router/withRouter';
import loadData from './tag_page_state_manager';
import { tagAllFeedAllStoriesRendered } from '../../../../redux/action_creators/tag/tag_all_feed_action_creators';
import {
  isAdvertorial,
  isCustom
} from '../../../components/advertorial/advertorial';

import loadable from '@loadable/component';

const LoadingSpinner = loadable(() =>
  import('../../../components/loading_spinner/loading_spinner')
);
const FeatureFeed = loadable(() =>
  import('../../../components/feature_feed/feature_feed')
);
const AdContainer = loadable(() =>
  import('../../../components/ad/AdContainer')
);
const NotFound = loadable(() =>
  import('../../../components/not_found_component/not_found_component')
);
const Slug = loadable(() => import('../../../components/slug/slug'));
const VideoModule = loadable(() =>
  import('../../../components/video_module/video_module')
);
const AllFeed = loadable(() => import('../../../components/all_feed/all_feed'));
const Advertorial = loadable(() =>
  import('../../../components/advertorial/advertorial')
);

// eslint-disable-next-line react/prefer-stateless-function

function formatTags(tagPromoterChannelFcWorks) {
  let postCopy = {};
  if (
    !tagPromoterChannelFcWorks ||
    (tagPromoterChannelFcWorks && tagPromoterChannelFcWorks.length === 0)
  ) {
    return [];
  }
  tagPromoterChannelFcWorks.map(post => {
    postCopy = post;
    postCopy.tags =
      typeof postCopy.tags === 'string' ? postCopy.tags.split(',') : post.tags;
    return postCopy;
  });

  return tagPromoterChannelFcWorks;
}
class Tag extends Component {
  static loadData(store, override) {
    return loadData(store, override);
  }

  /**
   * Determines whether or not to display the video module for a given tag ID.
   * @param {number} tagId - The ID of the tag to check.
   * @returns {boolean} - Whether or not to display the video module.
   */
  shouldDisplayVideoModule(tagId) {
    const exemptTags = [
      163674, // Plugged In
      164258, // Modern CEO
      85219, // Work Smarter
      164698, // Smart Run Grow
      21601, // Workplace Evolution
      138969, // BWI
      164250, // Growth Engines
      15736, // Secrects of the Most Productive People
      105528, // Future of Work
      159577, // Climate Solutions
      88159, // Business Transformation
      109481, // Solopreneurs
      15669, // Fast Company Innovation Festival
      164477, // AI Decoded
      67160, // Cybersecurity
      159916, // Financing the Future
      153692, // Next Big Things in Tech
      39705, // Marketing Innovation
      147370, // Small to Fast
      38815 // Artificial Intelligence
    ];

    return !exemptTags.includes(tagId);
  }

  render() {
    const ad = isAdvertorial(get(this.props.tagAllFeed, 'posts[0].tags'));
    const custom = isCustom(get(this.props.tagAllFeed, 'posts[0].tags'));
    let url = get(this.props, 'match.url', '');
    url = url.match(/\/(.*?)\//m);

    // eslint-disable-next-line no-console
    // console.log("URl ", url[1], " ad ", ad, " test ", (url && url[1] === 'section' && ad))
    if (
      this.props.tagPage.error ||
      this.props.tagFeaturedFeed.error ||
      (url && url[1] === 'section' && ad && !custom) ||
      (url && url[1] === 'brandworks' && !ad)
    ) {
      return (
        <section className="tag-page">
          <article className="tag-page__main--error-pg">
            <NotFound />
          </article>
        </section>
      );
    }

    if (this.props.tagPage.isLoading) {
      return (
        <section className="tag-page">
          <article className="tag-page__main">
            <LoadingSpinner />
          </article>
        </section>
      );
    }

    const { config, tagFeaturedFeed, tagAllFeed } = this.props;
    const tagId = get(tagFeaturedFeed, 'tag.id');
    const pgName = get(tagFeaturedFeed, 'tag.name');
    const pgDesc = get(tagFeaturedFeed, 'tag.description');
    const tags = get(tagAllFeed, 'posts[0].tags');
    const advertorial = isAdvertorial(tags);
    const page = get(this.props, 'match.params.page', false);
    const totalPages = get(this.props, 'tagAllFeed.totalPages');
    // const showLogo = pgName === 'Small to Fast';
    let isLastPage = Number(page) === totalPages;
    const isTagSponsored =
      tagFeaturedFeed?.tag?.advancedFields?.acf?.tag_is_sponsored;
    const tagSponsorLabel =
      tagFeaturedFeed?.tag?.advancedFields?.acf?.tag_sponsor_label;
    const tagSponsorLink =
      tagFeaturedFeed?.tag?.advancedFields?.acf?.tag_sponsor_link;
    const tagSponsorImageUrl =
      tagFeaturedFeed?.tag?.advancedFields?.acf?.tag_sponsor_image?.url;
    const isPluggedInTag = get(tagFeaturedFeed, 'tag.id') === 163674;
    const isModernCEOTag = get(tagFeaturedFeed, 'tag.id') === 164258;
    const isWorkSmarterTag = get(tagFeaturedFeed, 'tag.id') === 85219;
    const isGrowthEnginesTag = get(tagFeaturedFeed, 'tag.id') === 164250;
    const isWorkplaceEvolutionTag = get(tagFeaturedFeed, 'tag.id') === 21601;
    const isStartRunGrowTag = get(tagFeaturedFeed, 'tag.id') === 164698;
    const isBWITag = get(tagFeaturedFeed, 'tag.id') === 138969;
    if (!page) {
      if (totalPages === 1) {
        isLastPage = true;
      }

      return (
        <section
          className={`tag-page ${advertorial ? 'tag-page--advertorial' : ''}`}
        >
          {advertorial && !custom ? (
            <Advertorial modifier="tag-page" tags={tags} />
          ) : (
            ''
          )}
          {advertorial && !custom ? (
            <AllFeed
              stories={get(this.props, 'tagAllFeed.posts')}
              allRendered={get(this.props, 'tagAllFeed.allRendered')}
              updateAction={tagAllFeedAllStoriesRendered}
              config={config}
              tags={get(this.props, 'tagAllFeed.posts[0].tags')}
              advertorialSlugs={get(this.props, 'tagFeaturedFeed.tag')}
              modifier="advertorial"
            />
          ) : (
            <div>
              <section className="page-title">
                <Slug slugName={pgName} className="tag-page" />
                {/* {showLogo && (
                  <div className="smallToFast">
                    <span>PRESENTED BY</span>
                    <img
                      className="tmobileLogo"
                      src="https://images.fastcompany.net/image/upload/v1622657695/fcweb/TMO_Business_Lockup_EN_RGB_on-W_oeetmj.svg"
                      alt="presented by t mobile"
                    />
                  </div>
                )} */}
                {pgDesc ? (
                  <h3
                    className="page-description"
                    dangerouslySetInnerHTML={{ __html: pgDesc }}
                  />
                ) : (
                  ''
                )}
              </section>

              {isTagSponsored && (
                <section className="tag-page__sponsor">
                  <div className="tag-page__sponsor-inner">
                    <div className="tag-sponsor-container">
                      <span className="tag-sponsor-label">
                        {tagSponsorLabel}
                      </span>
                      <div className="tag-sponsor-logo">
                        <a href={tagSponsorLink || '#'}>
                          <img
                            alt={`sponsoring brand logo for ${tagSponsorLabel}`}
                            src={tagSponsorImageUrl}
                            width={150}
                            height={62}
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </section>
              )}

              <FeatureFeed
                featuredFeed={this.props.tagFeaturedFeed}
                promoBanner={this.props.tagPromoBanner}
                scrollingModule={this.props.tagScrollingModule}
                promoterChannelFcWorks={this.props.tagPromoterChannelFcWorks}
                config={config}
                page="tag"
                featuredSponsoredCard={this.props.featuredSponsoredCard}
                noAds={isPluggedInTag}
              />

              {get(this.props, 'tagFeaturedFeed.top.length') >= 2 &&
              !isPluggedInTag &&
              !isWorkSmarterTag ? (
                <div className="tag-page__ff-ad-container">
                  <AdContainer type="break" />
                </div>
              ) : (
                ''
              )}

              {this.shouldDisplayVideoModule(tagId) && (
                <Fragment>
                  <VideoModule
                    config={config}
                    type="tag"
                    data={this.props.tagVideo}
                    playerid="HliaKwd3"
                    stories={this.props.tagVideo.playlist}
                  />

                  {get(this.props, 'tagFeaturedFeed.top.length') &&
                  !isModernCEOTag &&
                  !isGrowthEnginesTag &&
                  !isWorkplaceEvolutionTag &&
                  !isStartRunGrowTag &&
                  !isBWITag ? (
                    <div className="tag-page__ff-ad-container">
                      <AdContainer type="break" />
                    </div>
                  ) : (
                    ''
                  )}
                </Fragment>
              )}

              <AllFeed
                stories={get(this.props, 'tagAllFeed.posts')}
                allRendered={get(this.props, 'tagAllFeed.allRendered')}
                updateAction={tagAllFeedAllStoriesRendered}
                config={config}
                paginationEnabled={true}
                page={Number(get(this.props, 'match.params.page', '1')) + 1}
                section={get(this.props, 'match.params.tag')}
                type="section"
                isLastPage={isLastPage}
                titleOverride={`All ${pgName} Stories`}
              />
            </div>
          )}
        </section>
      );
    }

    return (
      <section className="tag-page">
        <section className="page-title page-title--paginated">
          <Slug slugName={pgName} className="tag-page" />
          {pgDesc ? <h3 className="page-description">{pgDesc}</h3> : ''}
        </section>
        <AllFeed
          hasSlug={false}
          stories={get(this.props, 'tagAllFeed.posts')}
          allRendered={get(this.props, 'tagAllFeed.allRendered')}
          updateAction={tagAllFeedAllStoriesRendered}
          config={config}
          paginationEnabled={true}
          page={Number(get(this.props, 'match.params.page', '1')) + 1}
          section={get(this.props, 'match.params.tag')}
          type="section"
          isLastPage={isLastPage}
        />
      </section>
    );
  }
}

function mapStateToProps(state = {}) {
  return {
    config: state.config || {},
    status: state.status.code,
    featuredSponsoredCard: get(state, 'featuredSponsoredCard.data') || {},
    tagPromoterChannelFcWorks: formatTags(
      get(state, 'tagPromoterChannelFcWorks.channelFcWorksPosts', [])
    ),
    tagFeaturedFeed: {
      featured: get(state, 'tagFeaturedFeed.featured') || [],
      top: get(state, 'tagFeaturedFeed.top') || [],
      tag: get(state, 'tagFeaturedFeed.tag') || {},
      source: get(state, 'tagFeaturedFeed.source') || '',
      error: get(state, 'tagFeaturedFeed.error') || false
    },
    tagVideo: get(state, 'tagVideo.data') || {
      playlist: [],
      title: '',
      feedid: ''
    },
    tagPage: get(state, 'tagPage') || { error: true },
    tagScrollingModule: get(state, 'tagScrollingModule.data') || {},
    tagPromoBanner: get(state, 'tagPromoBanner.data') || {},
    tagAllFeed: {
      totalPosts: get(state, 'tagAllFeed.data.totalPosts', 0),
      totalPages: get(state, 'tagAllFeed.data.totalPages', 0),
      allRendered: get(state, 'tagAllFeed.data.allRendered', false),
      posts: get(state, 'tagAllFeed.data.posts', [])
    }
    // scrollingModule: get(state, 'scrollingModule.data.posts') || []
  };
}

Tag.propTypes = {
  config: PropTypes.shape({}).isRequired,
  tagPage: PropTypes.shape({
    isLoading: PropTypes.bool,
    error: PropTypes.bool,
    errorMessage: PropTypes.string
  }).isRequired,
  tagPromoterChannelFcWorks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  tagFeaturedFeed: PropTypes.shape({
    featured: PropTypes.arrayOf(PropTypes.shape({})),
    top: PropTypes.arrayOf(PropTypes.shape({})),
    tag: PropTypes.object,
    source: PropTypes.string,
    error: PropTypes.bool
  }).isRequired,
  tagVideo: PropTypes.shape({
    playlist: PropTypes.arrayOf(PropTypes.shape({})),
    feedid: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  tagScrollingModule: PropTypes.shape({}).isRequired,
  tagPromoBanner: PropTypes.shape({}).isRequired,
  featuredSponsoredCard: PropTypes.shape({}).isRequired,
  tagAllFeed: PropTypes.shape({
    posts: PropTypes.arrayOf(PropTypes.shape({})),
    allRendered: PropTypes.bool,
    totalPages: PropTypes.number,
    totalPosts: PropTypes.number
  }).isRequired
};

export default withRouter(connect(mapStateToProps)(Tag));
